import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { regionChange } from '../../actions';
import { Dropdown } from '../../components/Dropdown';
import { getFilterRegionId, getRegionsForSelect } from '../../selectors';
import { TThunkDispatch } from '../../types/redux/thunk';
import { addQueryParameter } from '../../utils';

export function RegionDropdown() {
  const dispatch: TThunkDispatch = useDispatch();
  const regions = useSelector(getRegionsForSelect);
  const selectedRegion = useSelector(getFilterRegionId);

  const handleRegionChange = React.useCallback(
    (regionId: number) => {
      dispatch(regionChange(regionId));
      addQueryParameter('regionId', String(regionId));
    },
    [dispatch],
  );

  return <Dropdown label="Регион" options={regions} selected={selectedRegion} onChange={handleRegionChange} />;
}
